import React, { cloneElement, useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import { AnnualPreviewDeductibleItem } from '../../../@types/AnnualPreview.type';
import {
	capitalizeFirstLetter,
	formatCurrency,
} from '../../../shared/utils/general.util';

const AnnualPreviewItemDropdown = ({
	deductibles,
	index,
}: {
	deductibles: AnnualPreviewDeductibleItem;
	index: number;
}) => {
	const [showDropdown, setShowDropdown] = useState(false);

	return (
		<div
			className='text-xs md:text-sm'
			style={{
				animation: 'fadeInScale 0.150s ease forwards',
				animationDelay: `${index * 40}ms`,
				opacity: 0,
			}}
		>
			<button
				onClick={() => setShowDropdown(!showDropdown)}
				className='flex items-center justify-between w-full bg-h-neutral-95 hover:bg-h-neutral-90/50 p-3 rounded-xl gap-2'
			>
				<div className='w-6 h-6'>
					{cloneElement(deductibles.icon as React.ReactElement, {
						size: 18,
					})}
				</div>
				<div className='w-full flex flex-col gap-1 text-left'>
					<p className='font-medium'>{deductibles.label}</p>
					<p className='font-light'>{deductibles.invoices.length} facturas</p>
				</div>
				<p className='font-medium md:text-base' >{formatCurrency(deductibles.total)}</p>
				<CaretDown
					className={`min-w-4 min-h-4 ${showDropdown ? 'rotate-180' : ''}`}
					weight='bold'
				/>
			</button>

			{showDropdown && (
				<div className='flex flex-col gap-2 px-4 py-4'>
					{deductibles.invoices.map((item, index) => {
						return (
							<div
								key={index}
								className='flex justify-between gap-10'
								style={{
									animation: 'fadeInScale 0.150s ease forwards',
									animationDelay: `${index * 40}ms`,
									opacity: 0,
								}}
							>
								<p className='truncate font-light'>
									{capitalizeFirstLetter(item.concept)}
								</p>
								<p className='font-medium'>{formatCurrency(item.total)}</p>
							</div>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default AnnualPreviewItemDropdown;
